<div>
  @if (profile && !loading) {
    <div class="d-flex">
      <div class="profile-info m-b-20" style="width: 100%">
        <div class="cover-photo" [ngStyle]="{ 'background-image': coverPhoto ? 'url(' + coverPhoto + ')' : 'url(./assets/images/studio-one-plus-profile-banner.png)' }">
          <div class="profile-back-container">
            <button type="button" class="btn btn-transparent p-0" (click)="helperService.goBack()" aria-label="back">
              <fa-icon icon="arrow-left" class="circle-icon-btn" aria-hidden="true"></fa-icon>
              <span class="sr-only">back</span>
            </button>
          </div>
          <div class="profile-photo-container">
            <img
              [src]="
                profile.photo && (profile.id == user.id || profile.public || isFeatured)
                  ? profile.photo + (userService.profilePhotoCacheBuster ? '?' + userService.profilePhotoCacheBuster : '')
                  : './assets/images/default_avatar.jpg'
              "
              class="profile-photo"
              [alt]="
                'profile.profile_photo_alt' | translate: { name: profile.feature ? profile.feature.name : profile.firstName && profile.lastName ? profile.firstName + ' ' + profile.lastName : 'user' }
              "
            />
          </div>
        </div>
        <div class="profile-details d-flex m-t-50">
          <div>
            <fui-heading
              [text]="profile.feature ? profile.feature.name : profile.firstName && profile.lastName ? profile.firstName + ' ' + profile.lastName : ('com.no_name_entered' | translate)"
              [level]="5"
            ></fui-heading>
            <div>
              @if (account_id == user.id) {
                <a class="small-btn" tabindex="0" role="link" [routerLink]="['/account/general']">{{ "profile.edit_profile" | translate }}</a>
              }
              @if (user.is_admin) {
                <button class="small-btn" (click)="uploadWare()">{{ "profile.upload_exchange_item" | translate }}</button>
              }
              @if (user.is_admin) {
                <button class="small-btn" (click)="moderate()">{{ "profile.moderate" | translate }}</button>
              }
            </div>
            @if (profile.public || isFeatured || profile.id == user.id) {
              <span>{{ profile.tagline }}</span>
            }
            @if (communityService.communityWizards[profile.id]) {
              <div class="w-full m-t-10">
                {{ "profile.community_moderator_description" | translate: { name: profile.firstName } }}
              </div>
            }
          </div>
        </div>
        @if (!profile.public && !isFeatured && user.active_subscription) {
          <div class="profile-content m-t-50">
            {{ (profile.id == user.id ? "com.your_profile_private" : "com.their_profile_private") | translate }}
            @if (profile.id == user.id) {
              <div>
                <span class="small-btn blue" (click)="makePublic()">{{ "com.make_public" | translate }}</span>
              </div>
            }
          </div>
        }
        <div class="w-full align-items-center d-flex justify-content-between m-t-50">
          @if (profile && (profile.public || profile.id == user.id || isFeatured)) {
            <div class="profile-content text-left">
              <ul class="nav nav-pills justify-content-center">
                <li class="nav-item">
                  <a
                    class="nav-link"
                    (click)="switchSection('about')"
                    tabindex="0"
                    href="javascript:void(0)"
                    (keyup.enter)="switchSection('about')"
                    [class.active]="displayedSection.id == 'about'"
                    [attr.aria-current]="displayedSection.id == 'about' ? 'page' : false"
                  >
                    {{ "com.about" | translate }}
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    (click)="switchSection('posts')"
                    tabindex="0"
                    href="javascript:void(0)"
                    (keyup.enter)="switchSection('posts')"
                    [class.active]="displayedSection.id == 'posts'"
                    [attr.aria-current]="displayedSection.id == 'posts' ? 'page' : false"
                  >
                    {{ "com.posts" | translate }}
                  </a>
                </li>
                @if (wares && wares.data.length) {
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      (click)="switchSection('exchangecontent')"
                      tabindex="0"
                      href="javascript:void(0)"
                      (keyup.enter)="switchSection('exchangecontent')"
                      [class.active]="displayedSection.id == 'exchangecontent'"
                    >
                      {{ "com.exchange_content" | translate }}
                    </a>
                  </li>
                }
                @if (account_id == user.id && ((connections && connections.length) || (invites && invites.length))) {
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      (click)="switchSection('connections')"
                      tabindex="0"
                      href="javascript:void(0)"
                      (keyup.enter)="switchSection('connections')"
                      [class.active]="displayedSection.id == 'connections'"
                    >
                      {{ "com.connections" | translate }}
                    </a>
                  </li>
                }
                @if (account_id == user.id) {
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      (click)="switchSection('pinned_posts')"
                      tabindex="0"
                      href="javascript:void(0)"
                      (keyup.enter)="switchSection('pinned_posts')"
                      [class.active]="displayedSection.id == 'pinned_posts'"
                    >
                      {{ "com.pinned_posts" | translate }}
                    </a>
                  </li>
                }
              </ul>
            </div>
          }
          @if (account_id != user.id && profile.public) {
            <div>
              @if (!connectionStatus) {
                <button class="btn btn-primary" (click)="showConnectModal()">
                  <fa-icon icon="plus"></fa-icon>
                  {{ "com.connect" | translate }}
                </button>
              }
              @if (connectionStatus && connection.initiated_by == user.id) {
                <span class="gothic t-14 m-r-5">
                  <fa-icon icon="check"></fa-icon>
                  {{ (connectionStatus == "accepted" ? "com.connected" : "com.invite_sent") | translate }}
                </span>
              }
              @if (connectionStatus && connectionStatus == "pending" && connection.initiated_by == profile.id) {
                <div class="d-flex align-items-center">
                  <span class="m-r-10">{{ "profile.connection_requested" | translate }}</span>
                  <span class="btn btn-primary" (click)="reviewConnection(connection)">{{ "general.review" | translate }}</span>
                </div>
              }
              @if (connectionStatus && connectionStatus == "accepted") {
                <fa-icon icon="comments" class="action circle-icon-btn m-r-5" [ngbTooltip]="'com.send_message' | translate" (click)="sendMessage()"></fa-icon>
              }
              @if (connectionStatus && connectionStatus == "accepted") {
                <fa-icon icon="ellipsis-h" class="action circle-icon-btn" [ngbTooltip]="'sphere.options' | translate" (click)="showOptions()"></fa-icon>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
  <myp-inline-loader [loading]="loading" height="400px" spinnerName="myItemsExchange"></myp-inline-loader>
  @if (profile && !loading && (profile.public || profile.id == user.id || isFeatured)) {
    @if (displayedSection.id == "about") {
      <div>
        <h2 class="section-header">{{ "profile.edit.description" | translate }}</h2>
        <div class="m-b-20">
          @if (profile.feature || profile.description) {
            <span class="description" [innerHTML]="profile.feature ? profile.feature.htmlDescription : profile.htmlDescription"></span>
          }
          @if (!profile.feature && !profile.description) {
            <div class="m-y-20 gothic">
              {{ (profile.id == user.id ? "com.you_no_description" : "com.they_no_description") | translate: { name: profile.firstName } }}
            </div>
          }
        </div>
        @if (profile.id == user.id || (mySkills && mySkills.length)) {
          <h2 class="section-header">{{ "com.skills_word" | translate }}</h2>
          <div class="m-b-20">
            @for (skill of mySkills; track skill) {
              <div class="list-item hover dontgrow">
                <div class="list-item-container">
                  <div class="main-data">
                    <h3 class="title">{{ "com.skills." + skill.string_id | translate }}</h3>
                    @if (skill.is_service || skill.notes) {
                      <span class="sub-data">
                        @if (skill.is_service) {
                          <div>{{ "com.offered_as_service" | translate }}</div>
                          <!-- <div *ngIf="skill.hourly_rate">Hourly rate: ${{ skill.hourly_rate }}</div> -->
                        }
                        @if (skill.notes) {
                          <div [innerHTML]="skill.htmlNotes"></div>
                        }
                      </span>
                    }
                  </div>
                </div>
              </div>
            }
            @if (!mySkills || !mySkills.length) {
              <div class="m-y-20">
                <span class="brandfont-bold">{{ "com.no_skills_added" | translate }}</span>
                <br />
                <span>{{ "com.skills_desc" | translate }}</span>
              </div>
            }
            @if (account_id == user.id) {
              <div>
                <a class="small-btn" tabindex="0" role="link" [routerLink]="['/account/skills']">{{ "com.add_edit_skills" | translate }}</a>
              </div>
            }
          </div>
        }
        @if (profile.id == user.id || (showcases && showcases.length)) {
          <h2 class="section-header">{{ "com.showcases" | translate }}</h2>
          <div class="m-b-50">
            @for (showcase of showcases; track showcase) {
              <div class="m-t-30">
                <span class="t-20 bold m-b-20 d-block">{{ showcase.description }}</span>
                <myp-waveform-comments [showComments]="false" #waveformComments [isPostAttachment]="true" [file]="showcase"></myp-waveform-comments>
                <div class="d-flex flex-wrap align-items-center position-relative">
                  <span class="t-12 text-muted">{{ "com.skills_word" | translate }}:</span>
                  @for (channel of showcase.skills; track channel) {
                    <span class="showcase-selected-skill">{{ "com.skills." + channel.string_id | translate }}</span>
                  }
                </div>
              </div>
            }
            @if (!showcases || !showcases.length) {
              <div class="m-y-20">
                <span class="brandfont-bold">{{ "com.no_showcases_added" | translate }}</span>
                <br />
                <span>{{ "com.showcases_desc" | translate }}</span>
              </div>
            }
            @if (account_id == user.id) {
              <div>
                <a class="small-btn" tabindex="0" role="link" [routerLink]="['/account/showcases']">{{ "com.add_showcase" | translate }}</a>
              </div>
            }
          </div>
        }
      </div>
    }
    @if (displayedSection.id == "posts" || displayedSection.id == "pinned_posts") {
      <div>
        <div class="text-left">
          <ul class="comments-li">
            @for (post of communityService.activeParentPosts; track post; let i = $index) {
              <li>
                <myp-comment [comment]="post" [isCommunityPost]="true" [replies]="communityService.activeParentThreadMap[post.key]" [index]="i"></myp-comment>
              </li>
            }
          </ul>
          @if (displayedSection.id == "pinned_posts" && !loadingPins && noPins) {
            <div class="m-t-50">
              {{ "com.no_pinned_posts" | translate }}
            </div>
          }
          @if (displayedSection.id == "posts" && !loadingPosts && noPosts) {
            <div class="m-t-50">{{ "com.no_posts_to_display" | translate }}</div>
          }
        </div>
      </div>
    }
    @if (displayedSection.id == "exchangecontent") {
      <div class="m-b-30">
        <div>
          @if (!loading && wares && wares.data.length) {
            <div>
              <myp-exchange-list
                (itemTapped)="viewAsset($event)"
                (filterByCategory)="selectWareCategory($event)"
                [creator_id]="account_id"
                [wares]="filteredWares"
                [filterCategories]="wareCategories"
              ></myp-exchange-list>
            </div>
          }
          @if (wares && wares.data && !wares.data.length) {
            <div class="m-y-50">
              {{ isMe ? ("exchange.havent_created_anything" | translate) : ("sphere.user_not_created_anything" | translate) }}
            </div>
          }
        </div>
      </div>
    }
    @if (displayedSection.id == "connections") {
      <div>
        @if (invites && invites.length) {
          <div class="m-b-20">
            <h2 class="section-header">{{ "profile.pending_invites" | translate }}</h2>
            @for (invite of invites; track invite) {
              <myp-list-item
                [photo]="invite?.photoURL ? invite.photoURL : './assets/images/default_avatar.jpg'"
                [title]="invite.firstName + ' ' + invite.lastName"
                [imageRound]="true"
                [item]="invite"
                (itemClicked)="reviewConnection(invite)"
                [subData]="['profile.invited_you_to_connect_on' | translate: { date: (invite.created | date) }]"
              >
                <div class="button-content">
                  <span class="m-r-10">{{ "general.review" | translate }}</span>
                </div>
              </myp-list-item>
            }
          </div>
        }
        @if (connections && connections.length) {
          <div>
            <h2 class="section-header">{{ "profile.my_connections" | translate }}</h2>
            <div class="item-filter m-b-10">
              <div class="filter-input no-max-width">
                <input type="text" [(ngModel)]="connectionFilter" (ngModelChange)="doFilter()" [placeholder]="'com.type_to_filter' | translate" />
                @if (connectionFilter) {
                  <div class="clear" (click)="connectionFilter = ''; doFilter()"><fa-icon icon="times"></fa-icon></div>
                }
              </div>
            </div>
            @for (connection of displayedConnections; track connection) {
              <myp-list-item
                [photo]="connection?.photoURL ? connection.photoURL : './assets/images/default_avatar.jpg'"
                [title]="connection.firstName + ' ' + connection.lastName"
                [item]="connection"
                [inactive]="connection.status == 'pending'"
                [subData]="['profile.status_label' | translate: { status: (connection.status | titlecase) }]"
                (itemClicked)="goToConnection($event)"
              >
                <div class="button-content">
                  <fa-icon
                    icon="ellipsis-h"
                    placement="left"
                    (click)="connectionOptions($event, connection)"
                    [ngbTooltip]="'sphere.options' | translate"
                    class="action circle-icon-btn m-r-10"
                  ></fa-icon>
                </div>
              </myp-list-item>
            }
          </div>
        }
      </div>
    }
  }
</div>
